import * as React from 'react';
const { connect } = require('react-redux');
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { IStore } from 'redux/IStore';
import { ICookieTypes, IUserProfileData } from 'models/user/userprofile';
import { Button } from '../Common/Button';
import { acceptCookies } from 'redux/modules/user/userprofile';
import { syncHistoryWithStore } from 'react-router-redux';
import { store } from '../../../../src/client';
const config = require('../../../../config/main');
const { browserHistory } = require('react-router');
import * as ReactGA from 'react-ga';
import { CustomerCheckboxField } from 'containers/Shop/ShopBundlesServicesAddEdit/ShopServicesSingleAddEdit/CustomerCheckboxField';
import renderIcon from 'helpers/renderIcon';

interface IProps {
	userprofile?: IUserProfileData;

	t?: (key: string) => string;
	acceptCookies?: (cookieTypes: ICookieTypes) => IUserProfileData;
}

interface IState {
	manageCookiesOpened: boolean;
	necesarryCookie: boolean;
	analyticsCookie: boolean;
	marketingCookie: boolean;
}

@connect(
	(state: IStore) => ({
		userprofile: state.userprofile,
	}),
	(dispatch) => ({
		acceptCookies: (cookieTypes: ICookieTypes) => dispatch(acceptCookies(cookieTypes)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class CookieBanner extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);
		this.state = {
			manageCookiesOpened: false,
			necesarryCookie: this.props.userprofile.cookies.types.necesarry,
			analyticsCookie: this.props.userprofile.cookies.types.analytics,
			marketingCookie: this.props.userprofile.cookies.types.marketing,
		};
		this.handleSaveCookies = this.handleSaveCookies.bind(this);
		this.handleManageCookies = this.handleManageCookies.bind(this);
		this.handleAnalyticCookiesClick = this.handleAnalyticCookiesClick.bind(this);
		this.handleMarketingCookiesClick = this.handleMarketingCookiesClick.bind(this);
	}

	public componentDidMount(): void {
		/////////////////////////////////
		// Initialize google-analytics after user has already accepted cookies
		/////////////////////////////////
		if (this.props.userprofile.cookies.hasAcceptedCookies && this.props.userprofile.cookies.types.analytics) {
			ReactGA.initialize(config.app.googleSettings.analyticsId);
			const history = syncHistoryWithStore(browserHistory, store);
			history.listen((location) => {
				ReactGA.set({ page: location.pathname });
				ReactGA.pageview(location.pathname);
			});
		}
		/////////////////////////////////
	}

	public componentDidUpdate(prevProps: Readonly<IProps>): void {
		/////////////////////////////////
		// Set google-analytics cookies after user accepts cookies and analytics type cookie
		/////////////////////////////////
		if (
			!prevProps?.userprofile?.cookies?.hasAcceptedCookies &&
			this.props.userprofile.cookies.hasAcceptedCookies &&
			this.props.userprofile.cookies.types.analytics
		) {
			ReactGA.initialize(config.app.googleSettings.analyticsId);
			const history = syncHistoryWithStore(browserHistory, store);
			history.listen((location) => {
				ReactGA.set({ page: location.pathname });
				ReactGA.pageview(location.pathname);
			});
		}
		/////////////////////////////////
	}

	private handleSaveCookies() {
		this.props.acceptCookies({
			necesarry: this.state.necesarryCookie,
			analytics: this.state.analyticsCookie,
			marketing: this.state.marketingCookie,
		});
	}
	private handleManageCookies() {
		this.setState({ manageCookiesOpened: !this.state.manageCookiesOpened });
	}
	private handleAnalyticCookiesClick() {
		this.setState({ analyticsCookie: !this.state.analyticsCookie });
	}
	private handleMarketingCookiesClick() {
		this.setState({ marketingCookie: !this.state.marketingCookie });
	}

	public render() {
		const { t, userprofile } = this.props;
		const { manageCookiesOpened, necesarryCookie, analyticsCookie, marketingCookie } = this.state;
		const hasAcceptedCookies = userprofile.cookies.hasAcceptedCookies;
		const relativePath = window?.location?.pathname;

		return (
			<div>
				{!hasAcceptedCookies ? (
					<div>
						<div className={`cookies-banner-container ${relativePath === '/' ? 'landing-page' : ''}`}>
							<div className="container">
								<div className="row">
									<div className="col-12">
										<div className="cookies-banner">
											<div className="title-container d-flex justify-content-between">
												<h2 className="cookies-banner__title">{t('BSPortal_Cookies')}</h2>
											</div>

											<div className="body-container">
												<p className="cookies-banner__text">
													{t('BSPortal_Cookies_Text_Short')}{' '}
													<a href="/cookiepolicy/en" className="cookies-banner__text__link">
														{t('BSPortal_Common_ReadMore')}
													</a>
												</p>
											</div>

											<div className="cookies-banner__toggleContainer" onClick={this.handleManageCookies}>
												{t('BSPortal_Cookies_ManageCookies')}
												{renderIcon(
													'dropdown',
													16,
													16,
													`cookies-banner__toggleIcon ${manageCookiesOpened ? 'opened' : ''}`,
												)}
											</div>

											{manageCookiesOpened ? (
												<div className="manage-cookies-container d-flex flex-column">
													<CustomerCheckboxField
														input={{ name: 'necesarry', checked: necesarryCookie }}
														meta={{}}
														type="checkbox"
														label={t('BSProtal_Cookies_Cookie_NecesarryCookies')}
														isDisabled={true}
														dontShowCustomer={true}
													/>
													<CustomerCheckboxField
														input={{ name: 'analytics', checked: analyticsCookie }}
														meta={{}}
														onChangeAction={this.handleAnalyticCookiesClick}
														type="checkbox"
														label={t('BSProtal_Cookies_Cookie_AnalyticCookies')}
														dontShowCustomer={true}
													/>

													<CustomerCheckboxField
														input={{ name: 'marketing', checked: marketingCookie }}
														meta={{}}
														onChangeAction={this.handleMarketingCookiesClick}
														type="checkbox"
														label={t('BSProtal_Cookies_Cookie_MarketingCookies')}
														dontShowCustomer={true}
													/>
												</div>
											) : null}

											<div
												className={`buttons-container d-flex flex-column flex-sm-row ${
													manageCookiesOpened ? 'manage' : ''
												}`}
											>
												<Button onClick={this.handleSaveCookies}>{t('BSPortal_Cookies_SaveCookies')}</Button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div className="cookies-banner-background" />
					</div>
				) : null}
			</div>
		);
	}
}

export default CookieBanner;
